module.exports = __webpack_public_path__ + "img/pinoff.81c492d7.png";